import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteBlogFn, getBlogFn } from 'Services/Blog';
import { deleteTestimonialFn, getTestimonialFn } from 'Services/Testimonial';

const Testimonial = () => {
    const navigate = useNavigate();

    const { data: getTestimonial, refetch } = useQuery({
        queryKey: "get-blogs",
        queryFn: getTestimonialFn
    });

    const { mutate: deleteBlog } = useMutation(deleteTestimonialFn, {
        onSuccess: (response) => {
            toast.success("Deleted Successfully");
            refetch();
        }
    });

    const deleteHandle = (id) => {
        const formData = new FormData();
        formData.append("testimonial_id", id);
        deleteBlog(formData);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    Testimonial
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/testimonial/add`)}
                >
                    Add
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {getTestimonial?.data?.data?.map((item) => (
                    <Card key={item.id} className="bg-white shadow-lg rounded-lg">
                        <CardMedia
                            component="img"
                            style={{ height: '200px', objectFit: 'cover' }}
                            image={imageURL(item.image)}
                            alt={item.name}
                        />
                        <CardContent>
                            <Typography
                                variant="h6"
                                component="div"
                                className="mb-2 line-clamp-2"
                            >
                                {item.name}
                            </Typography>


                            <Typography
                                variant="body2"
                                color="textSecondary"
                                className="line-clamp-3"
                            >
                                {item.message}
                            </Typography>
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/testimonial/update/${item?.id}`)}
                            >
                                <EditIcon />
                                Update
                            </Button>
                            <Button
                                size="small"
                                color="error"
                                onClick={() => deleteHandle(item.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default Testimonial;
